import {
  USER_LOADING,
  AUTH_TOKEN,
  AUTH_ERROR,
  SSO_USER,
  SSO_COMPLETE,
  REGISTER_USER,
  LOGIN_USER,
  LOAD_USER,
  REFRESH_USER,
  UPDATE_USER,
  LOGOUT_USER,
  USER_TOKEN_NAME,
  RESET_USER,
  LIST_USER,
  LIST_USER_ERROR,
} from "../constants";
import { setInternalAuthHeader } from "../../utils/axios.InternalConfig";
import { User } from "../../types/user";

const initial_state: User = {
  loading: false,
  errors: {},
  details: {
    id: 0,
    email: "",
    name: "",
    admin: false,
    active_int: 0,
    permissions: [],
    cppPermissions: [],
  },
  userKey: "",
  isAuthenticated: false,
  userToken: sessionStorage.getItem(USER_TOKEN_NAME) || "", // User JWT
  isSsoAuthenticated: false,
  ssoPayload: {
    vendor: "",
    authData: null,
  },
  resetPasswordStatus: 0,
  list: [],
  totalResults: 0,
};

if (initial_state.userToken) {
  setInternalAuthHeader(initial_state.userToken);
}

interface stateOptions {
  type: string;
  payload?: any;
}

export default function UserReducer(state = initial_state, { type, payload }: stateOptions) {
  switch (type) {
    case USER_LOADING:
      return {
        ...state,
        loading: true,
      };

    case AUTH_ERROR:
      return {
        ...state,
        errors: payload,
      };

    case AUTH_TOKEN:
      setInternalAuthHeader(payload);
      sessionStorage.setItem(USER_TOKEN_NAME, payload);

      return {
        ...state,
        userToken: payload,
      };

    case REGISTER_USER:
      return {
        ...state,
      };

    case SSO_USER:
    case LOGIN_USER:
    case UPDATE_USER:
      return {
        ...state,
        ...payload,
        errors: {},
        loading: false,
        isAuthenticated: true,
      };

    case LOAD_USER:
      return {
        ...state,
        errors: {},
        loading: false,
        details: payload.user,
        userKey: payload.client_key,
        isAuthenticated: true,
      };

    case REFRESH_USER:
      return {
        ...state,
        errors: {},
        loading: false,
        details: payload,
      };

    case LOGOUT_USER:
      setInternalAuthHeader(); // Clear the token from the API
      sessionStorage.clear(); // Clear the user data from the session

      // remove initial_state token
      initial_state.userToken = "";

      return {
        ...initial_state,
      };

    case SSO_COMPLETE:
      return {
        ...state,
        isSsoAuthenticated: true,
        ssoPayload: {
          vendor: payload.vendor,
          authData: payload.authData,
        },
      };

    case RESET_USER:
      return {
        ...state,
        resetPasswordStatus: payload,
      };

    case LIST_USER:
      return {
        ...state,
        list: payload.results,
        totalResults: payload.totalResults,
      };

    case LIST_USER_ERROR:
      return {
        ...state,
        list: [],
      };

    default:
      return state;
  }
}
